import styled from "styled-components";
import { FlexBox } from "@pagepro-monorepo/ui/lib/components/styles/Grid";

import { DotProps } from "./types";

export const Embla = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
`;

export const EmblaViewport = styled.div`
  overflow: hidden;
`;

export const EmblaContainer = styled.ul`
  display: flex;
  align-items: center;
`;

export const EmblaSlide = styled.li`
  flex: 0 0 100%;
  min-width: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
`;

export const Button = styled.button`
  border: 0;
  background-color: transparent;
  transition: ${({ theme }) => theme.transition};
  transition-property: color, opacity;
  cursor: pointer;
  padding: 0.5rem;

  svg {
    height: 1em;
    width: 1.3em;
    font-size: 0.9375rem;
    fill: currentColor;
  }

  &:disabled {
    opacity: 0.4;
    pointer-events: none;
  }

  &:hover {
    color: ${({ theme }) => theme.colors.accent};
  }
`;

export const DotsWrapper = styled(FlexBox)`
  z-index: 0;
`;

export const Dot = styled.div<DotProps>`
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 50%;
  background-color: ${({ theme, isActive }) =>
    isActive ? theme.colors.accent : theme.colors.primary};
`;
